import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const documentCenteredPadding: NodeRenderer = (node, children) => (
  <div className="p-1 text-center">{children}</div>
)
